import { Link } from '@/components/Elements';
import { BILLING_PORTAL_URL } from '@/config';
import { SettingsLayout } from '@/features/settings/components/Layout';
import { useUser, useUserPermission } from '@/lib/auth';
import { useTranslation } from 'react-i18next';
import { ProfileSection } from '../components/ProfileSection';

export const UserProfilePage = () => {
  const { t } = useTranslation();
  const { data: user } = useUser();
  const { isOnlyBasicLicense } = useUserPermission();

  return (
    <SettingsLayout>
      <ProfileSection title={t('会員情報')}>
        <div>{user?.email}</div>
      </ProfileSection>

      {user?.hasPaymentCustomer && (
        <ProfileSection title={t('契約状況')}>
          <Link className="text-sm" to={BILLING_PORTAL_URL} target="_blank">
            {t('請求情報の管理')}
          </Link>
        </ProfileSection>
      )}

      {isOnlyBasicLicense && (
        <Link
          to="/subscription"
          state={{ display_basic: false }}
          target="_self"
        >
          {t('Plusプランにアップグレード')}
        </Link>
      )}
    </SettingsLayout>
  );
};
